<template>
  <svg
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="none"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true">
    <path
      d="M14 3v10.5a3.2 3.2 0 1 1-2.4-3.1"
      stroke="currentColor" />
    <path
      d="M14 3c.4 2.6 2 4.2 4.6 4.5"
      stroke="#25f4ee" />
    <path
      d="M14.6 4.4c.9 1.9 2.4 2.9 4 3.1"
      stroke="#fe2c55"
      stroke-width="1.6"
      opacity="0.85" />
  </svg>
</template>
